import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import React from "react";

export const getUserLabel = (user) => {
  let retVal = "";

  if (user.first_name === undefined) return retVal;

  if (user.first_name != null && user.first_name !== "") retVal += user.first_name;
  if (user.last_name != null && user.last_name !== "") {
    retVal !== "" ? (retVal += " " + user.last_name) : (retVal += user.last_name);
  }
  if (retVal === "" && user.username != null) {
    // no name found, take username
    retVal += user.username;
  }
  return retVal;
};

export const getUserNameById = (id, fetch = false, userQueue, setUserQueue, extraUsers = []) => {
  //console.log("get user name by id: ", id);
  if (id === null || id === undefined) {
    return "";
  }

  // try also extra users
  for (let i = 0; i < extraUsers.length; i++) {
    if (extraUsers[i].id === id) {
      return getUserLabel(extraUsers[i]);
    }
  }

  if (fetch) {
    let clone = [...userQueue];
    for (let i = 0; i < userQueue.length; i++) {
      if (userQueue[i].id === id) {
        return "-";
      }
    }
    clone.push({ id: id, status: "new" });
    setUserQueue(clone);
  }

  return "-"; // user not listed
};

export const getLabelStringOfModel = (fk_model, fk_id, fk_description = null) => {
  switch (fk_model) {
    case "Resources":
      if (fk_id === undefined || fk_id == null) return t("goto_vehicle");
      else if (fk_description !== null) return fk_description;
      else return t("Fahrzeug", null, "capital") + " " + fk_id;
    case "Users":
      if (fk_id === undefined || fk_id == null) return t("goto_user");
      else return t("user", null, "capital") + " " + fk_id;
    case "Facilities":
      if (fk_id === undefined || fk_id == null) return t("goto_facility");
      else return t("facility", null, "capital") + " " + fk_id;
    case "Orders":
      if (fk_id === undefined || fk_id == null) return t("goto_order");
      else return t("order", null, "capital");
  }
  return "";
};

export const getObjectReference = (fk_model, fk_id) => {
  switch (fk_model) {
    case "Users":
      if (Biscuit.get("user.role") === "garage-staff") return "#";
      return "users/" + fk_id;
    case "Resources":
      return "resources/" + fk_id;
    case "Orders":
      return "orders/" + fk_id + "/edit";
    case "Facilities":
      return "facilities/" + fk_id;
  }
};

export const getShortDescription = (desc, maxLength) => {
  if (desc === undefined || desc == null) return "";
  if (desc.length > maxLength) return desc.substring(0, maxLength) + "...";
  return desc;
};

export const getDescription = (task, userQueue, setUserQueue, extraUsers) => {
  let title = "";
  switch (task.fk_model) {
    case "Users":
      title = t("user", null, "capital");
      break;
    case "Orders":
      title = t("order", null, "capital");
      break;
    case "Resources":
      title = t("resource", null, "capital");
      break;
    case "Locations":
      title = t("location", null, "capital");
      break;
    case "Facilities":
      title = t("facility", null, "capital");
      break;
  }

  return (
    <>
      <div
        style={task.status === "new" ? { width: "100%" } : { width: "100%", fontWeight: "normal" }}
      >
        {task.name}
      </div>
      {task.fk_model !== "" && (
        <div className="show-label" style={{ width: "100%", fontSize: ".8125rem" }} title={title}>
          <a target="_blank" href={getObjectReference(task.fk_model, task.fk_id)}>
            {typeof task.fk_description !== "undefined" &&
              task.fk_description != null &&
              task.fk_description !== "" && <>{task.fk_description}</>}
            {typeof task.fk_description === "undefined" ||
              task.fk_description == null ||
              (task.fk_description === "" && (
                <>
                  {task.fk_model === "Users"
                    ? t("object", null, "capital") +
                      ": " +
                      getUserNameById(task.fk_id, true, userQueue, setUserQueue, extraUsers)
                    : t("object", null, "capital") +
                      ": " +
                      getLabelStringOfModel(
                        task.fk_model,
                        task.fk_id,
                        false,
                        userQueue,
                        setUserQueue,
                        extraUsers,
                      )}
                </>
              ))}
          </a>
        </div>
      )}
      {task.description !== undefined && task.fk_description !== task.description && (
        <>
          <div className="task-desc-small" title={task.description}>
            {getShortDescription(task.description, 58)}
          </div>
        </>
      )}
    </>
  );
};
